import { RootState } from '@dealstack/frontend/app/redux/store';

// User ID of the organization user
export const selectSelectedOrganizationUserId = (state: RootState) =>
	state.organization.selectedOrganizationUserId;
